import type { CssConstants } from "~/styles/exports/constants"
import values from "~/styles/tokens/eases.json"

export const eases: CssConstants = {
  values,
  toCss: () =>
    Object.entries(values)
      .map(([name, value]) => `$ease-${name}: cubic-bezier(${value});`)
      .join("\n"),
}
